<template>
  <div class="bookHome">
    <!-- <div class="tabPage3">
      <span
        :class="{ spanAct: pags.categoryId === '1' }"
        @click="tabClick('1')"
      >
        专业书籍</span
      >
      <span :class="{ spanAct: pags.categoryId === '2' }" @click="tabClick('2')"
        >航海阅读</span
      >
    </div> -->
    <div class="he20"></div>
    <div class="bookHome-box">
      <router-link
        v-for="(item, index) in list"
        :key="index"
        :to="{
          path: 'book/details',
          query: { id: item.id }
        }"
        tag="div"
        class="boxItem"
      >
        <el-image :src="item.cover"></el-image>
        <div class="boxItemMain">
          <div class="boxItemMain-title">{{ item.name }}</div>
          <div class="boxItemMain-text">{{ item.introduction }}</div>
          <div class="boxItemMainfooter">
            <div class="boxItemMain-unit">￥{{ item.price }}</div>
            <div class="boxItemMain-button" @click.stop="tabPayBook(item.id)">
              购买咨询
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="pags.total"
      :page-size.sync="pags.pageSize"
      class="pageBox"
      :pager-count="5"
      @current-change="changePage"
    ></el-pagination>
    <div class="he50"></div>
  </div>
</template>

<script>
import { getPeriodicalList } from "@/api/api.js";

export default {
  name: "PcbookHome",
  data() {
    return {
      pags: {
        pageNum: 1,
        pageSize: 5,
        total: 1,
        categoryId: ""
      },
      // category: "1",
      list: [],
      shopid: ""
    };
  },
  mounted() {
    this.getPeriodicalList();
  },
  methods: {
    tabClick(val) {
      this.pags.pageNum = 1;
      this.pags.pageSize = 5;
      this.pags.total = 1;
      this.pags.categoryId = val;
      this.getPeriodicalList();
    },
    getPeriodicalList() {
      this.list = [];
      getPeriodicalList(this.pags).then(res => {
        if (res.code === 0) {
          this.list = res.data.list;
          this.pags.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    changePage(val) {
      this.pags.pageNum = val;
      this.getPeriodicalList();
    },
    tabPayBook(id) {
      this.$router.push({
        name: "H5bookpayBook",
        query: { id: id }
      });
    }
  }
};
</script>

<style lang="less">
.bookHome {
  padding: 16px;
  box-sizing: border-box;
  .tabPage3 {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      padding: 5px 24px;
      border: 1px solid rgba(108, 45, 102, 1);
      color: #6c2c66;
      margin: 0 20px;
      cursor: pointer;
      border-radius: 4px;
      font-weight: bold;
    }
    .spanAct {
      color: #ffffff;
      background: rgba(108, 45, 102, 1);
    }
  }
  &-box {
    width: 100%;
    .boxItem {
      display: flex;
      margin-bottom: 16px;
      width: 100%;
      box-sizing: border-box;
      .el-image {
        width: 84px;
        height: 114px;
      }
      .boxItemMain {
        width: calc(100% - 84px);
        padding-left: 16px;
        box-sizing: border-box;
        &-title {
          width: 100%;
          font-size: 16px;
          font-weight: bold;
          color: rgba(52, 52, 52, 1);
        }
        &-text {
          width: 100%;
          // margin: 10px 0 20px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(52, 52, 52, 1);
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .boxItemMainfooter {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .boxItemMain-unit {
          // margin-bottom: 20px;
          font-size: 16px;
          font-weight: bold;
          color: rgba(255, 26, 26, 1);
        }
        .boxItemMain-button {
          width: 72px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          background: rgba(108, 44, 102, 1);
          cursor: pointer;
        }
      }
    }
  }
  .pageBox {
    text-align: center;
    margin: 30px auto 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0f4581;
  }
}
</style>
